import { Stack } from '@superdispatch/ui';
import { TextBox, TextColorProp } from '@superdispatch/ui-lab';
import { formatNumber } from 'shared/helpers/IntlHelpers';
import {
  formatVehicleDimensions,
  hasVehicleDimension,
} from 'shared/helpers/VehicleHelpers';
import { PostingVehicleDTO } from '../../data/dto/PostingLoadDTO';

interface Props {
  color?: TextColorProp;
  vehicle: PostingVehicleDTO;
}

export function PostingVehicleDimensions({ color, vehicle }: Props) {
  return (
    <Stack space="xxsmall">
      {!hasVehicleDimension(vehicle) ? (
        <TextBox color="secondary">Dimensions not available</TextBox>
      ) : (
        <TextBox color={color}>{formatVehicleDimensions(vehicle)}</TextBox>
      )}

      {!vehicle.curb_weight ? (
        <TextBox color="secondary">Curb Weight not available</TextBox>
      ) : (
        <TextBox color={color}>
          Curb Weight: ~ {formatNumber(vehicle.curb_weight)}{' '}
          {vehicle.curb_weight_unit || 'lbs'}
        </TextBox>
      )}
    </Stack>
  );
}
